import moment from 'moment'
import ft from '../featureToggle'

export default {
  getList (VueApp, data, callback) {
    let promo = VueApp.$store.state.promo
    VueApp.$sdk.get('/promo', {
      token: VueApp.$store.state.session.sessionToken,
      search: promo.search,
      pageNum: promo.currentPage,
      pageSize: promo.perPage,
      order: promo.order,
      orderAsc: promo.orderAsc
    }, res => {
      if (!res.error) {
        let list = []
        res.list.forEach(function (data) {
          let totalCodes = data.totalCodes || 0
          let codesUsed = data.redeemedCount || 0
          list.push({
            id: data.id,
            name: data.name,
            promoCode: data.code,
            creditAmount: data.amount,
            createdDate: moment(data.created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
            starDate: moment(data.startDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
            expDate: moment(data.expirationDate, 'YYYY-MM-DD@HH:mm:ss').add(data.validDays, 'days').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
            totalCodes: totalCodes,
            validDays: data.validDays,
            codesUsed: codesUsed,
            codesLeft: totalCodes - codesUsed,
            enabled: data.enabled
          })
        })

        VueApp.$store.commit('promo/setList', list)
        VueApp.$store.commit('promo/setMaxList', res.paging.totalItems)
      }
      callback(res)
    })
  },
  deactivate (VueApp, id, callback) {
    VueApp.$sdk.delete('/promo/' + id + '/enabled', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  activate (VueApp, id, callback) {
    VueApp.$sdk.post('/promo/' + id + '/enabled', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  getPromoDetails (VueApp, id, callback) {
    VueApp.$sdk.get('/promo/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('promo/setViewDetails', {
          adminId: res.adminId,
          id: res.id,
          name: res.name,
          description: res.description,
          startDate: moment(res.startDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
          expirationDate: moment(res.expirationDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
          validNewUser: res.validOnlyForNewUser ? 'Yes' : 'No',
          validServices: 'All',
          validDays: res.validDays,
          code: res.code,
          amount: res.amount,
          totalCodes: res.totalCodes,
          redeemedCodes: res.redeemedCount || 0
        })
      }
      callback(res)
    })
  },
  getViewList (VueApp, id, callback) {
    let promo = VueApp.$store.state.promo.view
    VueApp.$sdk.get('/promo/' + id + '/usage', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: promo.currentPage,
      pageSize: promo.perPage,
      order: promo.order,
      orderAsc: promo.orderAsc
    }, res => {
      if (!res.error) {
        let list = []
        let ctr = 1
        res.list.forEach(function (data) {
          let redeemDate = ''
          let expirationDate = ''
          if (data.redeemedDate) {
            redeemDate = moment(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
            expirationDate = moment(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').add(promo.details.validDays, 'days').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
          }
          list.push({
            id: data.id,
            placed: ((promo.currentPage - 1) * promo.perPage) + ctr,
            promoCode: data.promoCode || promo.details.code,
            status: data.redeemedDate ? 'Redeemed' : 'Not Redeemed',
            conID: data.contactId,
            redeemedDate: redeemDate,
            expirationDate: expirationDate
          })
          ctr++
        })

        VueApp.$store.commit('promo/setViewList', list)
        VueApp.$store.commit('promo/setViewMaxList', res.paging.totalItems)
      }
      callback(res)
    })
  },
  getViewListFull (VueApp, id, callback) {
    let promo = VueApp.$store.state.promo
    VueApp.$sdk.get('/promo/' + id + '/usage', {
      token: VueApp.$store.state.session.sessionToken,
      pageNum: 1,
      pageSize: 9999,
      order: 'id',
      orderAsc: 0
    }, res => {
      if (!res.error) {
        let list = []
        let ctr = 1

        let viewDetails = promo.view.details
        let promoCode = viewDetails.code
        let validDays = viewDetails.validDays
        let index = promo.list.findIndex(x => x.id === id)
        if (id !== viewDetails.id && index > -1) {
          validDays = VueApp.$store.state.promo.list[index].validDays
          promoCode = VueApp.$store.state.promo.list[index].promoCode
        }
        res.list.forEach(function (data) {
          let redeemDate = ''
          let expirationDate = ''
          if (data.redeemedDate) {
            redeemDate = moment(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
            expirationDate = moment(data.redeemedDate, 'YYYY-MM-DD@HH:mm:ss').add(validDays, 'days').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
          }
          list.push({
            '#': ctr,
            'Promo Code': data.promoCode || promoCode,
            'Status': data.redeemedDate ? 'Redeemed' : 'Not Redeemed',
            'Consumer ID': data.contactId,
            'Redeemed Date': redeemDate,
            'Expiration Date': expirationDate
          })
          ctr++
        })
        callback(list)
        return
      }
      callback(res)
    })
  },
  savePromoDetails (VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/promo/' + data.id, data, res => {
      callback(res)
    })
  },
  addPromoDetails (VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/promo/', data, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/promo/index.js